<nav aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    @for (
      item of items; track trackByFn(i,
      item); let last = $last; let i = $index) {
      <hyperkit-breadcrumb
        [text]="item.text"
        [link]="item.link"
        [selected]="item.selected || false"
        (clicked)="breadcrumbClick.emit(i)"
      ></hyperkit-breadcrumb>
      <!-- Chevron separator between items -->
      @if (!last) {
        <li
          class="breadcrumb-separator-container"
          aria-hidden="true"
          >
          <hyperkit-icon
            color="primary"
            size="base"
            icon="chevron-right"
            aria-hidden="true"
          ></hyperkit-icon>
        </li>
      }
    }
  </ol>
</nav>
